// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6ebcc53","667":"f6745787","977":"395abc22"}[chunkId] + ".chunk.js";
};